import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ProfileInput = _resolveComponent("ProfileInput")!
  const _component_Sheet = _resolveComponent("Sheet")!

  return (_openBlock(), _createBlock(_component_Sheet, {
    onClose: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close'))),
    visibility: _ctx.showSheet,
    addPadX: true
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", null, [
        _createVNode(_component_ProfileInput, { placeholder: "Username" })
      ])
    ]),
    _: 1
  }, 8, ["visibility"]))
}